import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=5863ed0e&scoped=true&"
import script from "./AutoLogout.vue?vue&type=script&lang=js&"
export * from "./AutoLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863ed0e",
  null
  
)

export default component.exports